import React, { useEffect, useState } from 'react'
import Loader from '../../elements/Loader'
import { useDispatch, useSelector } from 'react-redux'
import ModalDialog from '../../layouts/ModalDialog'
import { ERROR } from '../../../store/types'
import { authHeader } from '../../../utils'
import axios from 'axios'
import ArrowIcon from '../../elements/icons/ArrowIcon'
import StudentCheckIn from '../exeats/StudentCheckIn'
import NewExeat from '../exeats/NewExeat'
import { clearCreatedExeat, fetchExeats } from '../../../store/actions/exeatsActions'
import ExeatCard from '../exeats/ExeatCard'
import moment from 'moment'

const StudentExeatsCheckIns = ({student}) => {
  const exeatsSelector = useSelector(state => state.exeats)
  const dispatch = useDispatch()

  const [loading, setLoading] = useState(true)
  const [currentTerm, setCurrentTerm] = useState(null)
  const [checkIns, setCheckIns] = useState([])
  const [checkOuts, setCheckOuts] = useState([])
  const [reload, setReload] = useState(0)
  const [viewType, setViewType] = useState('current-term'); // or 'all'

  useEffect(() => {
    const getCurrentTerm = async () => {
      try {
        const headers = authHeader()

        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/terms?currentlyActive=true`, { headers })
        console.log('terms response: ', response.data.data)        
        if(response.data.data.terms.length > 0) {
          const termId = response.data.data.terms[0]._id
          dispatch(fetchExeats(`student=${student._id}&term=${termId}&approvalStatus=pending,approved&status=pending,student-away`, 0, 0))
          getCheckIns(termId)
          setCurrentTerm(response.data.data.terms[0])
        }

        setLoading(false)
        
      } catch (error) {
        console.error('error getting current term: ', error)
        dispatch({
          type: ERROR,
          error
        })
      }
    }

    const getCheckIns = async (termId) => {
      try {
        const headers = authHeader()
        let url = `check-ins?student=${student._id}`
        if(viewType === 'current-term') url += `&term=${termId}`

        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/${url}&page=0&perPage=0&expand=recordedBy`, { headers })            
        
        setCheckIns(response.data.data.checkIns)
        getCheckOuts(termId)
        
      } catch (error) {
        console.error('error getting current term: ', error)
        dispatch({
          type: ERROR,
          error
        })
      }
    }

    const getCheckOuts = async (termId) => {
      try {
        const headers = authHeader()
        let url = `check-outs?student=${student._id}`
        if(viewType === 'current-term') url += `&term=${termId}`

        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/${url}&page=0&perPage=0&expand=exeat,recordedBy`, { headers })            
        
        setCheckOuts(response.data.data.checkOuts)
        setLoading(false)
        
      } catch (error) {
        console.error('error getting current term: ', error)
        dispatch({
          type: ERROR,
          error
        })
      }
    }

    if(viewType === 'all'){
      getCheckIns()
    }

    getCurrentTerm()

    if(exeatsSelector.createdExeat !== null){
      dispatch(clearCreatedExeat())
      setCreatingExeat(false)
    }
  
    return () => {
      
    }
  }, [dispatch, student._id, viewType, reload, exeatsSelector.createdExeat])
  
  const [creatingExeat, setCreatingExeat] = useState(false)
  const [checkingIn, setCheckingIn] = useState(false)
  const [checkingInForTerm, setCheckingInForTerm] = useState(false)

  const checkedInForCurrentTerm = () => {
    const checkedInForTerm = checkIns.findIndex(item => {
      return item.term === currentTerm._id && item.isTermResumption === true
    })
    return checkedInForTerm > -1
  }

  const combined = [
  ...checkIns.map(item => ({ ...item, type: "check-in" })),
  ...checkOuts.map(item => ({ ...item, type: "check-out" }))
].sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());

const hasActiveExeat = exeatsSelector?.exeats?.exeats?.some(exeat => exeat?.approval?.status === 'approved' && (exeat?.status === 'student-away' || exeat?.status === 'pending'))

  return (
    <>
      {loading ? 
        <Loader />
        :
        <div className="w-full">
            <div className='pb-3 mb-2'>
                <div className="w-full mx-auto">
                    <div className='w-full flex items-start justify-between'>
                        <div className='w-2/3'>
                            <h4 className='font-medium text-lg mb-1 text-gray-700'>Student Exeats, Check-outs & Check-ins</h4>
                            <p className='text-gray-500 text-sm'>
                              A list of all check-ins and check-outs of this student from the college. Any any active exeats for this student will be displayed below. Check-outs can only be recorded if there's a valid exeat for this student, and students can only be checked in from existing check-outs.
                            </p>
                        </div>
                        
                        <div className='flex flex-row-reverse gap-x-[10px]'>
                          {checkedInForCurrentTerm() && !hasActiveExeat && <button onClick={()=>{setCreatingExeat(true)}} className='rounded px-4 py-3 mt-4 text-sm text-purple-100 bg-vcm-purple transition duration-200 border border-vcm-purple hover:bg-vcm-light-purple hover:text-vcm-purple flex items-center justify-center gap-x-2'>
                              Create an Exeat
                          </button>}

                          {!checkedInForCurrentTerm() && <button onClick={()=>{setCheckingInForTerm(true)}} className='rounded px-4 py-3 mt-4 text-sm bg-vcm-light-purple transition duration-200 border border-vcm-purple hover:bg-gray-200 text-vcm-purple flex items-center justify-center gap-x-2'>
                            Check-in Student for the Term
                          </button>}
                        </div>
                    </div>

                    {/* <div className='w-full flex items-center justify-between my-5 p-2 rounded-md border'>
                        <div className='w-full'>
                            <InvoicesFilters applyFilters={(filters)=>{
                              console.log('filters => ', filters)
                              setFilters(filters)
                            }} 
                          />
                        </div>
                        <div className='w-full flex flex-row-reverse gap-x-2'>
                            <button onClick={()=>{}} className={`text-gray-700 px-3 py-2 hover:bg-gray-100 transition duration-200 text-sm flex items-center justify-center gap-x-2 bg-gray-200 rounded border`}>
                              <ArrowUpTrayIcon className={`w-5 h-5`} />
                              Export Invoices
                            </button>
                            <div className='w-[350px]'>
                              <SearchField 
                                placeholderText={`Search for invoice by name or invoice code`}
                                showResultsDropDown={false}
                                triggerSearch={(term)=>{searchApplicants(term)}}
                                performingSearch={invoicesSelector.loadingInvoices}
                              />
                            </div>
                        </div>
                    </div> */}

                    {!currentTerm && viewType === 'current-term' &&
                      <div className='bg-gray-100 border rounded-[8px] w-1/2 p-[20px] border-gray-100 bg-opacity-50 mt-[50px]'>
                        <p className='font-space-grotesk font-[550] w-full pb-[5px] border-b border-gray-400'>No Active Term</p>
                        <p className='text-sm mt-[10px]'>There is no currently active term at the college. When a student is checked in for a term, you can see all their check-ins and check-outs.</p>
                        <button onClick={()=>{setViewType('all')}} className='mt-[10px] font-space-grotesk text-sm font-[550] flex items-center gap-x-[5px]'>
                          See all Student Check-ins/Check-outs
                          <ArrowIcon className={`w-4 h-4`} />
                        </button>
                      </div>
                    }

                    {currentTerm && checkIns.length === 0 && viewType === 'current-term' && 
                      <div className='bg-gray-100 border rounded-[8px] w-1/2 p-[20px] border-gray-100 bg-opacity-50 mt-[50px]'>
                        <p className='font-space-grotesk font-[550] w-full pb-[5px] border-b border-gray-400'>Term Check-in pending</p>
                        <p className='text-sm mt-[10px]'>This student has not yet been checked in for the current term. Please check them in</p>
                        <button onClick={()=>{setViewType('all')}} className='mt-[10px] font-space-grotesk text-sm font-[550] flex items-center gap-x-[5px]'>
                          See all Student Check-ins/Check-outs
                          <ArrowIcon className={`w-4 h-4`} />
                        </button>
                      </div>
                    }

                    
                </div>
            </div>

            <div className='w-full'>
              {exeatsSelector.loadingExeats
                ? 
                  <div className='w-full'>
                      <Loader />
                  </div>
                : 
                  <>

                  {checkedInForCurrentTerm() && exeatsSelector.exeats.exeats.length > 0  && viewType === 'current-term' && 
                    <div className='w-full xl:w-2/3'>
                      <ExeatCard exeat={exeatsSelector.exeats.exeats[0]} reload={()=>{setReload(reload+1)}} openCheckIn={()=>setCheckingIn(true)} />
                    </div>
                  }

                  </>
                }
            </div>

            {!loading && 
              <div className='mt-[40px]'>
                {combined?.length > 0 && 
                  combined.map((item, itemIndex)=>(<div key={itemIndex} className={`w-full p-[20px] bg-gray-50 rounded-[8px] my-[10px] border ${item.type === 'check-in' ? 'border-green-400' : 'border-gray-200'}`}>
                    <div className='w-full flex items-start justify-between gap-x-[20px]'>
                      <div className='w-[50px]'>
                        <div className={`w-[50px] h-[50px] flex items-center justify-center bg-opacity-50 rounded ${item.type === 'check-in' ? 'bg-green-200' : ' bg-gray-300'}`}>
                          <ArrowIcon className={`w-[18px] h-[18px] ${item.type === 'check-in' ? 'text-green-600 rotate-[135deg]' : 'text-gray-600 -rotate-[45deg]'}`} />
                        </div>
                      </div>
                      <div className='w-4/12'>
                        <label className='text-xs mb-[5px] text-gray-500 block'>Description</label>

                        {item.type === 'check-out' ? 
                          <>
                            <p className='text-sm'>Picked up from the school premises on <br />{moment(item.createdAt).format('dddd, MMMM Do YYYY - HH:MM a')}</p> 
                            <p className='mt-[10px] text-sm text-gray-600'>Picked up by {item.exeat.pickup.name}</p>
                          </>
                        :
                          <p className='text-sm'>Arrived at the school premises on <br />{moment(item.createdAt).format('dddd, MMMM Do YYYY - HH:MM a')}</p>
                      }
                      </div>
                      <div className='w-6/12'>
                        <label className='text-xs mb-[5px] text-gray-500 block'>Remarks</label>
                        <p className='text-sm'>{item.note}</p>
                        <p className='text-sm mt-[10px] text-gray-600'>Checked by {item.recordedBy?.name}</p>
                      </div>
                      <div className='w-2/12 flex flex-row-reverse'>
                        {item.type === 'check-out' && <button onClick={()=>{}} className='p-[10px] rounded text-xs font-space-grotesk font-[550] bg-gray-300 border flex items-center justify-center gap-x-[5px] bg-opacity-60 transition duration-200 hover:bg-opacity-90'>
                            Exeat Details
                            <ArrowIcon className={`w-4 h-4 text-gray-400`} />
                        </button>}
                      </div>
                    </div>
                    {/* <p>{item.type}</p> */}
                  </div>))}
                
              </div>
            }
        </div>
      }

      <ModalDialog
        shown={creatingExeat} 
        closeFunction={()=>{setCreatingExeat(false)}} 
        actionFunction={()=>{}} 
        actionFunctionLabel={``}
        dialogTitle='Create a new Exeat'
        maxWidthClass='max-w-xl'
        hideActions={true}
      >
        <NewExeat 
          student={student} 
          term={currentTerm} 
          reload={()=>{setReload(reload+1)}}
          close={()=>{setCreatingExeat(false)}}
        />
      </ModalDialog>

      <ModalDialog
        shown={checkingIn} 
        closeFunction={()=>{setCheckingIn(false)}} 
        actionFunction={()=>{}} 
        actionFunctionLabel={``}
        dialogTitle='Check-in this student'
        maxWidthClass='max-w-md'
        hideActions={true}
      >
        <StudentCheckIn student={student} term={currentTerm} close={()=>setCheckingIn(false)} />
      </ModalDialog>

      <ModalDialog
        shown={checkingInForTerm} 
        closeFunction={()=>{setCheckingInForTerm(false)}} 
        actionFunction={()=>{}} 
        actionFunctionLabel={``}
        dialogTitle='Check-in this student for the current term'
        maxWidthClass='max-w-md'
        hideActions={true}
      >
        <StudentCheckIn 
          student={student} 
          term={currentTerm} 
          isForTerm={true} 
          reload={()=>{setReload(reload+1)}}
          close={()=>{setCheckingInForTerm(false)}}
        />
      </ModalDialog>


    </>
  )
}

export default StudentExeatsCheckIns